import React from 'react';
import { DownloadExcelButton } from '../../../helpers/ExcelGenerator';

// Shared client-side export for the Channel Orders tabs. Exports the currently
// visible rows, or — when the user has selected rows — just the selected ones.
// No API call; flattens each channel order into a sheet-friendly object.
const EXPORT_COLUMNS = [
  { label: 'Order No', value: 'order_number' },
  { label: 'Channel Order ID', value: 'channel_order_id' },
  { label: 'AWB', value: 'awb' },
  { label: 'Store', value: 'store_name' },
  { label: 'Channel', value: 'channel' },
  { label: 'Order Date', value: 'order_date' },
  { label: 'Customer', value: 'customer_name' },
  { label: 'Phone', value: 'customer_phone' },
  { label: 'Shipping Address', value: 'shipping_address' },
  { label: 'Items', value: 'items' },
  { label: 'Item Count', value: 'item_count' },
  { label: 'Amount', value: 'total_price' },
  { label: 'Payment Mode', value: 'payment_mode' },
  { label: 'Financial Status', value: 'financial_status' },
  { label: 'Status', value: 'status' },
  { label: 'Weight (g)', value: 'weight_g' },
  { label: 'Tags', value: 'tags' },
];

const buildExportRows = (rows) => (rows || []).map((r) => ({
  order_number: r.order_number ?? '',
  channel_order_id: r.channelOrderId ?? '',
  awb: r.awb || r.proshipOrder?.[0]?.awbNumber || r.lastfulfilledUnits?.awbNumber || '',
  store_name: r.store_name ?? '',
  channel: r.channel ?? '',
  order_date: r.order_date ?? '',
  customer_name: [r.shipping_address?.first_name, r.shipping_address?.last_name].filter(Boolean).join(' '),
  customer_phone: r.shipping_address?.phone || r.phone || '',
  shipping_address: [
    r.shipping_address?.address1,
    r.shipping_address?.address2,
    r.shipping_address?.city,
    r.shipping_address?.province || r.shipping_address?.state,
    r.shipping_address?.zip,
    r.shipping_address?.country,
  ].filter(Boolean).join(', '),
  items: (r.orderItems || []).map((it) => `${it.title || ''} (x${it.units || 0})`).join(' | '),
  item_count: (r.orderItems || []).length,
  total_price: r.total_price ?? '',
  payment_mode: r.payment_mode ?? '',
  financial_status: r.financial_status ?? '',
  status: r.channelOrderStatus ?? '',
  weight_g: r.total_weight ?? '',
  tags: r.tags ?? '',
}));

export default function ChannelOrderExportButton({ visibleRows, selectedRows, selectedCount, filename = 'channel_orders' }) {
  const hasSelection = (selectedCount || 0) > 0;
  const rows = hasSelection ? (selectedRows || []) : (visibleRows || []);
  return (
    <DownloadExcelButton
      filename={filename}
      sheetName="Channel Orders"
      buttonName={hasSelection ? `Export Selected (${selectedCount})` : 'Export'}
      data={buildExportRows(rows)}
      columns={EXPORT_COLUMNS}
    />
  );
}
